import { resolveViewerProfileIdentity } from "@/lib/core/auth";
import { matchingApiRequestSchema } from "./matching-api.contract";
import { readFreeRevealListingId } from "./runtime/compat-score-gate";
import { computeMatchScore } from "./runtime/compatibility";

export const matchingApiRoute = {
    server: {
        handlers: {
            GET: async ({
                params,
                request,
            }: {
                params: { listingId: string };
                request: Request;
            }) => {
                const url = new URL(request.url);
                const parsed = matchingApiRequestSchema.safeParse({
                    listingId: params.listingId,
                    comment: url.searchParams.get("comment") ?? undefined,
                    mode: url.searchParams.get("mode") ?? undefined,
                });
                if (!parsed.success) {
                    return Response.json(
                        { error: "listing_id is required." },
                        { status: 400 },
                    );
                }

                const auth = await resolveViewerProfileIdentity();
                if (!auth) {
                    return Response.json({ status: "locked" });
                }
                if (!auth.isAuthenticated) {
                    const revealed = await readFreeRevealListingId(
                        auth.appUserId,
                    );
                    if (revealed !== parsed.data.listingId) {
                        return Response.json({ status: "locked" });
                    }
                }

                try {
                    const result = await computeMatchScore({
                        listingId: parsed.data.listingId,
                        userId: auth.appUserId,
                        comment: auth.isAuthenticated
                            ? parsed.data.comment
                            : undefined,
                        scoringMode: auth.isAuthenticated
                            ? parsed.data.mode
                            : "deterministic",
                    });
                    return Response.json(result);
                } catch (error) {
                    const message =
                        error instanceof Error
                            ? error.message
                            : "Internal server error";
                    return Response.json({ error: message }, { status: 500 });
                }
            },
        },
    },
};
